module.exports = __webpack_public_path__ + "static/media/cape-town.cc940cc8.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/components/FlightsHome/img/cape-town.jpeg
// module id = 553
// module chunks = 0